export const ROLES = {
    COMPANY:"COMPANY",
    SUPER_ADMIN:"SUPER_ADMIN",
    OPERATOR:"OPERATOR",
    CUSTOMER:"CUSTOMER"
}